export var FileSourceEnum;
(function (FileSourceEnum) {
    FileSourceEnum["SUMSUB"] = "SUMSUB";
    FileSourceEnum["ZENDESK"] = "ZENDESK";
    FileSourceEnum["ADMIN"] = "ADMIN";
})(FileSourceEnum || (FileSourceEnum = {}));
//# sourceMappingURL=file-source.enum.js.map